import { ChangeDetectionStrategy, ChangeDetectorRef, Component, computed, CUSTOM_ELEMENTS_SCHEMA, effect, inject, input, signal } from '@angular/core';
import { AbstractControl, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { BaseFormField } from 'src/app/shared/form/abstracts';
import { StructureField } from 'src/app/shared/incidents-reporter/interfaces';
import { IncidentsReporterSurveyForm } from 'src/app/shared/incidents-reporter/services';

@Component({
  selector: 'app-single-response-field-wrapper',
  standalone: true,
  imports: [
    TranslateModule
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi:true,
      useExisting: SingleResponseFieldWrapperComponent 
    },
  ],
  templateUrl: './single-response-field-wrapper.component.html',
  styleUrls: ['./single-response-field-wrapper.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SingleResponseFieldWrapperComponent extends BaseFormField<string> {
  // Inputs
  public field = input<StructureField>();
  public form = input.required<FormGroup>();
  public formControlName = input.required<string>();
  
  // Service injections
  private _cdr = inject(ChangeDetectorRef);
  private _incidentsReporterSurveyFormService = inject(IncidentsReporterSurveyForm);
  
  // Computed properties
  private formControl = computed(() => this.form().get(this.formControlName()));
  
  // Local signal states
  protected showErrorMessage = signal<boolean>(false);
  
  // Effects
  markAllFieldsAsTouched = effect(() => {
    const control = this.formControl();
    this._markFieldsAsTouched(control, this._cdr);
  }, { allowSignalWrites: true });
  
  // Methods
  protected handleRadioButtonChange(event: Event): void {
    const customEvent = event as CustomEvent<{ value: string, checked: boolean}>;
    const selectedOption = customEvent.detail.value;
    if (!selectedOption) {
      this.showErrorMessage.set(true);
      return;
    } else {
      this.showErrorMessage.set(false);
    }
    
    this.formControl().setValue(selectedOption);
  }
  
  private _markFieldsAsTouched(control: AbstractControl | null, cdr: any): void {
    if (this._incidentsReporterSurveyFormService.markAllFormFieldsAsTouched()) {
      this._incidentsReporterSurveyFormService.markFieldAsTouched(control);

      if (this._incidentsReporterSurveyFormService.isInvalidField(control)) {
        this.showErrorMessage.set(true);
      }
      cdr.detectChanges();
    }
  }
}
